import { state, initializeState } from './state';
// @ts-ignore
import translations from './translations.json';


export { downloadsActions, useDownloads, DownloadsTypes } from './state';

export const downloads = {
    API: {
        domain: {},
    },

    state,

    environment: {
        initializationSagas: [
            initializeState,
        ],
    },

    translations,
};
